import { useEffect } from "react";
import "../Styles/methodology.css";


// ✅ IMPORT IMAGES FROM src/assets



export default function OurMethodology() {
  useEffect(() => {
    document.title = "Methodology| Outstanding Workplaces";
  }, []);
  return (
    <div className="omw-methodology-main">

      {/* Section 1 */}
      <section className="omw-methodology-section omw-methodology-section1">
        <div className="omw-methodology-text omw-methodology-text1">
          <h1>Our Methodology</h1>
          <p>
            At Outstanding Workplaces, our certification methodology is designed to balance employee voice with organizational practices, ensuring credibility, transparency, and actionable insights. The process begins with an eligibility check, where organizations confirm their size, scope, and commitment to participate. This is followed by a comprehensive Employee Experience Survey, which contributes 70% of the overall score. The survey captures authentic employee feedback on leadership trust, engagement, well-being, inclusivity,innovation,and sustainability.         </p>
        </div>

        <div className="omw-methodology-image-wrap omw-methodology-image-wrap1">
          <img
  src="/methodology-section1.png"
  alt="Methodology presentation"
  className="omw-methodology-image omw-methodology-image1"
/>
        </div>
      </section>

      {/* Section 2 */}
      <div className="omw-methodology-section2-bg">
        <section className="omw-methodology-section omw-methodology-section2">

          <div className="omw-methodology-image-wrap omw-methodology-image-wrap2">
           <img
  src="/leader.png"
  alt="Leadership and HR Practices Audit"
  className="omw-methodology-image omw-methodology-image2"
/>
          </div>

          <div className="omw-methodology-text omw-methodology-text2">
            <p>
              To complement employee perceptions, a Leadership and HR Practices Audit (30% weightage) is conducted, where organizational policies, HR metrics, diversity ratios, CSR/ESG initiatives, and leadership interviews are reviewed. Together, these inputs provide a holistic view of both how employees feel and what practices are in place.            </p>
          </div>

        </section>
      </div>

      {/* Section 3 */}
      <section className="omw-methodology-section omw-methodology-section3">
        <div className="omw-methodology-text omw-methodology-text3">
          <p>
Scores are benchmarked against industry and organization size, and ratings are awarded as Platinum, Gold, Silver, or Certified Outstanding Workplace. Organizations also receive a detailed feedback report outlining strengths and opportunities for improvement. Certification is valid for one year, with annual re-certification encouraging continuous growth.
Our methodology ensures that recognition is not just symbolic but a strategic enabler of transformation, competitiveness, and future readiness.          </p>
        </div>

        <div className="omw-methodology-image-wrap omw-methodology-image-wrap3">
          <img
  src="/methodology-section3.png"
  alt="Benchmarking"
  className="omw-methodology-image omw-methodology-image3"
/>
        </div>
      </section>

    </div>
  );
}